import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { Checkbox1Icon, Checkbox2Icon, Checkbox3Icon } from '../../icons';

export interface CheckedIconProps extends React.SVGProps<SVGSVGElement> {
  checked?: boolean;
  disabled?: boolean;
  intermediate?: boolean;
}
export function CheckedIcon({
  checked,
  disabled,
  intermediate,
  ...props
}: CheckedIconProps) {
  const theme = useTheme();
  return intermediate ? (
    <Checkbox2Icon {...props} />
  ) : checked ? (
    <Checkbox3Icon {...props} />
  ) : (
    <Checkbox1Icon {...props} />
  );
}
export default CheckedIcon;
